import {
  getStatusColor,
  getStatusIcon,
} from "@/Mixins/certificates/getStatusMixin.js";
import { canBeDownloaded, canBeReinstated, canBeRevoked } from "@/Mixins/certificates/getActionsMixin";
import moment from "moment";
import pgwyClient from "@/api/pgwyClient";
import * as constants from "@/config/constants";

export default {
  name: "certificates-table-view-dialog",
  props: ["currentCertificate", "fullView"],
  mixins: [getStatusColor, getStatusIcon, canBeDownloaded, canBeRevoked, canBeReinstated],
  data() {
    return {
      revokeReasonModel: null,
      revokeButtonLoader: false,
      reinstateButtonLoader: false,
      valid: false,
      revokeReasonRule: [(v) => !!v || "Reason is required"],
      textCopiedContainer: false,
      notExpired: this.currentCertificate.validity === "valid",
      showDetails: true,
      toggleSelect: false,
      revokeCont: false,
      reinstateCont: false,
      show: false,
      certDetailsOptions: {
        validityItems: [
          { title: "Valid from", id: 1 },
          { title: "Valid to", id: 2 },
          { title: "Status", id: 3 },
        ],
        issuerItems: [
          { title: "Common name", number: 1, id: 1 },
          { title: "Organisation", number: 2, id: 2 },
          { title: "Country", number: 3, id: 3 },
          { title: "Key identifier", id: 4 }
        ],
      },
    };
  },
  computed: {
    constants() {
      return constants;
    },
    certificates() {
      return [
        { key: "ID", value: this.currentCertificate.certid },
        {
          key: "Serial number",
          value: this.currentCertificate.certificateserialnumber,
        },
        { key: "Issuer", value: this.currentCertificate.issuer },
        { key: "Status", value: this.currentCertificate.status },
        { key: "Name", value: this.currentCertificate.subject },
        { key: "Valid from", value: this.currentCertificate.validfrom },
        { key: "Valid to", value: this.currentCertificate.validto },
      ];
    },
    // Change height to 100% if details is open
    certPopupHeight() {
      if (
        this.fullView ||
        this.revokeCont ||
        this.showDetails ||
        (this.reinstateCont && this.showDetails)
      ) {
        // return "100%";
      } else {
        switch (this.$vuetify.breakpoint.name) {
          // The width
          // Range - "max 600px"
          case "xs":
            return "100%";
          // Range - "min 600px, max 960px"
          case "sm":
            return "84rem";
          // Range - "min 960px, max 1264px"
          case "md":
            return "68rem";
          // Range - "min 1264px, max 1904px"
          case "lg":
            return "58rem";
          // Range - "min 1904px"
          case "xl":
            return "92vh";
        }
      }
    },
    size() {
      const size = {
        xs: "small",
        sm: "small",
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
    certImg() {
      switch (this.$vuetify.breakpoint.name) {
        // Mobile
        case "xs":
          return "80";
        case "sm":
          return "100";
        // Desktop
        case "md":
          return "100";
        case "lg":
          return "100";
        case "xl":
          return "100";
      }
    },
  },
  created() {
    // Capture certain keys via the normal Web API, Vue does not handle it well
    document.addEventListener('keyup', this.dialogKeyListener);
  },
  destroyed() {
    document.removeEventListener('keyup', this.dialogKeyListener);
  },
  methods: {
    // Verifies if the date format is correct
    changeDateFormat(value) {
      // The desired format
      const formTemplate = "YYYY/MM/DD hh:mm [CET]";
      // Checks if value matches the format
      const checkFormat = moment(value, formTemplate, true)
      // Returns true or false
      const result = checkFormat.isValid();

      // If result is true return value else convert to correct format
      if (result) {
        return value;
      } else {
        const timeformat = moment(value);
        const val = timeformat.format(formTemplate);
        return val;
      }
    },
    formatKey(val) {
      if (val) {
        return val.replace(/.{2}/g, '$& ');
      }
    },
    issuerFormat(val) {
      const str = this.currentCertificate.issuer;
      if (val === 1) {
        // Checks for cn= and stops before ,o=
        const match = str.match(/cn=(.*?),o=/);
        if (match) {
          const result = match[1];
          return result;
        }
      } else if (val === 2) {
        // Checks for o= and stops before ,c=
        const match = str.match(/o=(.*?),c=/);
        if (match) {
          const result = match[1];
          return result;
        }
      } else if (val === 3) {
        // checks from c=
        const match = str.match(/c=(.*)/);
        if (match) {
          const result = match[1];
          return result;
        }
      }
    },
    getCurrentText(val) {
      const text = "This certificate is";
      const statusVal = this.currentCertificate.status;
      const validVal = this.currentCertificate.validity;

      if (statusVal === "active" && validVal === "valid") {
        if (val === 2) {
          return "Active";
        } else {
          return text + " active";
        }
      } else if (
        statusVal === "revoked" &&
        this.currentCertificate.reason === "certificateHold"
      ) {
        if (val === 2) {
          return `${text} on hold (${this.currentCertificate.reason})`;
        } else {
          return `Revoked (${this.currentCertificate.reason})`;
        }
      } else if (statusVal === "revoked") {
        if (val === 2) {
          return `${text} revoked (${this.currentCertificate.reason})`;
        } else {
          return `Revoked (${this.currentCertificate.reason})`;
        }
      } else if (validVal === "notYetValid") {
        if (val === 2) {
          return "Not active";
        } else {
          return text + " not active yet";
        }
      } else if (validVal === "expired") {
        if (val === 2) {
          return `Expired`;
        } else return text + " expired";
      }
    },
    dialogKeyListener(evt) {
      if (evt.code === "Escape") {
        this.closeDialog();
      }
    },
    closeDialog() {
      this.revokeReasonModel = null;
      this.$emit("closeDialog");
      this.showDetails = true;
      this.revokeCont = false;
      this.reinstateCont = false;
    },
    changeView() {
      this.$emit("changeView");
    },
    revokeCertificateClicked() {
      this.valid = this.$refs.form.validate();
      if (this.valid && (this.revokeReasonModel != null)) {
        this.revokeButtonLoader = true;
        const reasonNumb = this.revokeReasonModel;

        pgwyClient.revokeCertificates([this.currentCertificate.certid], reasonNumb)
          .then(() => {
            this.$emit("updateCurrentCertificate");
            this.revokeButtonLoader = false;
            this.revokeReasonModel = null;
            this.revokeCont = false;
            this.reinstateCont = false;
            this.$emit("actionResponse", { success: true, type: "revoke" })
          })
          .catch((err) => {
            this.revokeButtonLoader = false;
            this.$emit("actionResponse", { message: err.response?.data?.msg || "Could not revoke certificate(s)" })
            // this.revokeReasonModel = null;
          });
      }
    },
    reinstateCertificateClicked() {
      this.reinstateButtonLoader = true;
      pgwyClient.reinstateCertificates([this.currentCertificate.certid])
        .then(() => {
          this.$emit("updateCurrentCertificate");
          this.reinstateButtonLoader = false;
          this.reinstateCont = false;
          this.$emit("actionResponse", { success: true, type: "reinstate" });
        })
        .catch((err) => {
          this.reinstateButtonLoader = false;
          this.$emit("actionResponse", { message: err.response?.data?.msg || "Could not reinstate certificate(s)" });
        });
    },
    downloadCertificateClicked(value) {
      this.$emit("downloadCertificateClicked", value);
    },
    copyMaterial(material) {
      this.textCopiedContainer = true;
      navigator.clipboard.writeText(material);
      setTimeout(() => {
        this.textCopiedContainer = false;
      }, 700);
    },
  },
};